export const PRINT_OUTPUT_INCLUDES_OPTION_VALUE_TABLE_AND_CHART_IF_AVAILABLE = 0
export const PRINT_OUTPUT_INCLUDES_OPTION_VALUE_TABLE_AND_CHART = 10
export const PRINT_OUTPUT_INCLUDES_OPTION_VALUE_TABLE_ONLY = 20
export const PRINT_OUTPUT_INCLUDES_OPTION_VALUE_CHART_ONLY = 30
